import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import size from "lodash/size";
import { NAMESPACE, NEW_SUMMARY_REPORT } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: { draft: {}, data: undefined, summaryReportId: undefined }
};
export default createReducer(initialState, {
    [actionTypes.SET_DRAFT]: (state, { draft }) => {
        const isDraftPartial = size(draft) === 1;
        return set(state, `[${NAMESPACE}].draft`, isDraftPartial && draft ? { ...state[NAMESPACE].draft, ...draft } : draft, {
            checkExistence: false,
            checkEqual: false
        });
    },
    [actionTypes.GET_SUMMARY_REPORT_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].data`, payload),
    [actionTypes.SET_SUMMARY_REPORT_ID]: (state, { summaryReportId }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            summaryReportId,
            data: summaryReportId === undefined ? undefined : state[NAMESPACE].data,
            draft: summaryReportId === undefined ? {} : state[NAMESPACE].draft
        }
    }),
    [actionTypes.SET_NEW_SUMMARY_REPORT]: (state, { projectId }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            summaryReportId: NEW_SUMMARY_REPORT.Id,
            data: { ...NEW_SUMMARY_REPORT, ProjectId: projectId },
            draft: {}
        }
    })
});
